import { render } from "./SellOrderSent.vue?vue&type=template&id=53b4cf47&scoped=true&ts=true"
import script from "./SellOrderSent.vue?vue&type=script&lang=ts"
export * from "./SellOrderSent.vue?vue&type=script&lang=ts"

import "./SellOrderSent.vue?vue&type=style&index=0&id=53b4cf47&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b4cf47"],['__file',"src/components/sell/SellOrderSent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53b4cf47"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53b4cf47', __exports__)) {
    api.reload('53b4cf47', __exports__)
  }
  
  module.hot.accept("./SellOrderSent.vue?vue&type=template&id=53b4cf47&scoped=true&ts=true", () => {
    api.rerender('53b4cf47', render)
  })

}


export default __exports__